<template>
  <header class="header-container">
    <div class="header-left">
      <!-- Logo -->
      <img 
        v-if="headerConfig.logo" 
        :src="$fixAssetUrl(headerConfig.logo)" 
        class="logo" 
        alt="Logo"
      />
      
      <!-- 语言切换：仅在配置加载完成后显示 -->
      <!-- <div v-if="configLoaded" class="lang-switch-wrapper">
        <div class="lang-switch" :class="{ active: showLangPopover }" @click="toggleLangPopover">
          <img 
            v-if="langIconPath"
            :src="$fixAssetUrl(langIconPath)" 
            class="lang-icon" 
            alt="Lang"
            @error="handleImageError"
          />
          <span class="lang-name">{{ langNameDisplay }}</span>
          <svg 
            class="arrow-icon" 
            width="10" 
            height="10" 
            viewBox="0 0 10 10" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M2.5 3.75L5 6.25L7.5 3.75" 
              stroke="#666" 
              stroke-width="1.2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
            />
          </svg>
        </div>
        
        <div v-if="showLangPopover" class="lang-dropdown-menu">
          <div 
            v-for="action in langActions" 
            :key="action.text"
            class="lang-dropdown-item"
            :class="{ active: selectedLang === action.text }"
            @click="onSelectLang(action)"
          >
            <img 
              v-if="action.icon"
              :src="$fixAssetUrl(action.icon)" 
              class="lang-dropdown-icon" 
              alt=""
            />
            <span>{{ action.text }}</span>
          </div>
        </div>
      </div> -->
    </div>

    <div class="header-right">
      <div class="open-app-btn" :style="openAppBtnStyle" @click="handleOpenApp">
        打开App
      </div>
      <div class="menu-icon" @click="toggleMenu">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 6H21" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 12H21" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 18H21" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <!-- 底部菜单弹窗 -->
    <BottomMenuPopup 
      :show="showMenu" 
      @close="showMenu = false"
      @update:show="showMenu = $event"
    >
      <!-- 首页 -->
      <div 
        class="menu-item" 
        :class="{ active: currentPath === '/' }"
        :style="getMenuItemStyle(currentPath === '/')"
        @click="navigateTo(menuItems[0])"
      >
        <div class="icon-wrapper">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip_home)">
              <path d="M9.58742 0.752078C9.70643 0.662826 9.85117 0.614578 9.99992 0.614578C10.1487 0.614578 10.2934 0.662826 10.4124 0.752078L19.5791 7.62708C19.725 7.73648 19.8214 7.89935 19.8472 8.07985C19.873 8.26035 19.826 8.44371 19.7166 8.58958C19.6072 8.73545 19.4443 8.83188 19.2638 8.85767C19.0833 8.88346 18.9 8.83648 18.7541 8.72708L18.0208 8.17708V12.7604C18.0208 15.0411 17.8063 16.8726 16.8447 18.1092C16.0866 19.0836 15.0416 19.1771 13.4374 19.1771V15.5104C13.4374 14.5987 13.0753 13.7244 12.4306 13.0797C11.7859 12.4351 10.9116 12.0729 9.99992 12.0729C9.08824 12.0729 8.2139 12.4351 7.56924 13.0797C6.92459 13.7244 6.56242 14.5987 6.56242 15.5104V19.1771C4.95826 19.1771 3.91325 19.0836 3.15517 18.1092C2.19359 16.8726 1.97909 15.0411 1.97909 12.7604V8.17708L1.24575 8.72799C1.09989 8.8374 0.916531 8.88437 0.736028 8.85859C0.555524 8.8328 0.392657 8.73636 0.283255 8.5905C0.173853 8.44463 0.126878 8.26127 0.152664 8.08077C0.178451 7.90026 0.274886 7.7374 0.420755 7.628L9.58742 0.752995V0.752078Z" :fill="getMenuIconColor(currentPath === '/')"/>
            </g>
            <defs>
              <clipPath id="clip_home">
                <rect width="20" height="20" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <span>首页</span>
      </div>
      <!-- 课程体系 -->
      <div 
        class="menu-item" 
        :class="{ active: currentPath === '/courses' }"
        :style="getMenuItemStyle(currentPath === '/courses')"
        @click="navigateTo(menuItems[1])"
      >
        <div class="icon-wrapper">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8251 1.82584C15.916 1.77831 16.0173 1.75391 16.1199 1.75478C16.2225 1.75565 16.3233 1.78177 16.4134 1.83084C18.2634 2.83917 18.9584 4.77334 18.9584 7.5V12.5C18.9584 14.645 18.5334 16.3083 17.4209 17.4208C16.3092 18.5333 14.6451 18.9583 12.5001 18.9583H7.50008C5.35508 18.9583 3.69175 18.5333 2.57925 17.4208C1.46675 16.3092 1.04175 14.645 1.04175 12.5V7.5C1.04175 4.77334 1.73675 2.84001 3.58675 1.83084L3.65675 1.79751C3.74625 1.76234 3.84267 1.7483 3.93848 1.75648C4.0343 1.76466 4.12694 1.79484 4.20919 1.84467C4.29143 1.8945 4.36107 1.96264 4.41268 2.04379C4.46429 2.12493 4.49648 2.21689 4.50675 2.31251C4.64508 3.6025 4.91175 5.00667 5.41925 6.07084C5.92508 7.12917 6.59091 7.70834 7.50008 7.70834H12.5001C13.4034 7.70834 14.0692 7.13084 14.5767 6.06917C15.0859 5.00584 15.3551 3.60167 15.4934 2.31251L15.5059 2.23667C15.5265 2.14929 15.5656 2.06736 15.6207 1.99647C15.6758 1.92557 15.7455 1.86738 15.8251 1.82584ZM5.00008 13.125C4.83432 13.125 4.67535 13.1909 4.55814 13.3081C4.44093 13.4253 4.37508 13.5842 4.37508 13.75C4.37508 13.9158 4.44093 14.0747 4.55814 14.1919C4.67535 14.3092 4.83432 14.375 5.00008 14.375H11.6667C11.8325 14.375 11.9915 14.3092 12.1087 14.1919C12.2259 14.0747 12.2917 13.9158 12.2917 13.75C12.2917 13.5842 12.2259 13.4253 12.1087 13.3081C11.9915 13.1909 11.8325 13.125 11.6667 13.125H5.00008ZM5.00008 9.79167C4.83432 9.79167 4.67535 9.85752 4.55814 9.97473C4.44093 10.0919 4.37508 10.2509 4.37508 10.4167C4.37508 10.5824 4.44093 10.7414 4.55814 10.8586C4.67535 10.9758 4.83432 11.0417 5.00008 11.0417H15.8334C15.9992 11.0417 16.1581 10.9758 16.2754 10.8586C16.3926 10.7414 16.4584 10.5824 16.4584 10.4167C16.4584 10.2509 16.3926 10.0919 16.2754 9.97473C16.1581 9.85752 15.9992 9.79167 15.8334 9.79167H5.00008ZM12.6692 1.04167C12.9438 1.04177 13.215 1.10216 13.4636 1.21857C13.7123 1.33498 13.9323 1.50457 14.1082 1.71537C14.2841 1.92616 14.4116 2.17301 14.4816 2.43848C14.5516 2.70394 14.5625 2.98154 14.5134 3.25167L14.1967 4.99334C14.1007 5.52126 13.8225 5.99876 13.4106 6.34262C12.9987 6.68647 12.4792 6.87488 11.9426 6.875H8.05841C7.52183 6.87488 7.00231 6.68647 6.59038 6.34262C6.17845 5.99876 5.90025 5.52126 5.80425 4.99334L5.48758 3.25167C5.43854 2.98161 5.44939 2.70408 5.51936 2.43868C5.58933 2.17327 5.71672 1.92646 5.89253 1.71568C6.06834 1.50491 6.28828 1.3353 6.53682 1.21883C6.78536 1.10237 7.05644 1.04189 7.33091 1.04167H12.6692Z" :fill="getMenuIconColor(currentPath === '/courses')"/>
          </svg>
        </div>
        <span>课程体系</span>
      </div>
      <!-- 师资力量 -->
      <div 
        class="menu-item" 
        :class="{ active: currentPath === '/teachers' }"
        :style="getMenuItemStyle(currentPath === '/teachers')"
        @click="navigateTo(menuItems[2])"
      >
        <div class="icon-wrapper">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.99992 10.2083C11.7799 10.2083 13.8516 10.4183 15.5033 11.0875C17.1641 11.76 18.5416 12.9725 18.5416 15C18.5416 15.9983 18.1866 16.7725 17.5583 17.33C16.9541 17.865 16.1491 18.155 15.3158 18.3217C13.6683 18.6492 11.5883 18.5417 9.99992 18.5417C8.41159 18.5417 6.33158 18.65 4.68409 18.3208C3.85075 18.155 3.04575 17.865 2.44242 17.3292C1.81325 16.7733 1.45825 15.9983 1.45825 15C1.45825 12.9725 2.83575 11.76 4.49659 11.0875C6.14825 10.4183 8.21992 10.2083 9.99992 10.2083ZM9.99992 1.45834C10.5198 1.45831 11.0345 1.56067 11.5148 1.75957C11.9951 1.95848 12.4315 2.25005 12.7991 2.61761C13.1667 2.98518 13.4583 3.42156 13.6572 3.90182C13.8561 4.38209 13.9585 4.89684 13.9585 5.41668C13.9585 5.93652 13.8561 6.45126 13.6572 6.93153C13.4583 7.4118 13.1667 7.84817 12.7991 8.21574C12.4315 8.58331 11.9951 8.87487 11.5148 9.07378C11.0345 9.27269 10.5198 9.37505 9.99992 9.37501C8.95015 9.37494 7.94341 8.95787 7.20113 8.21554C6.45886 7.47322 6.04186 6.46644 6.04186 5.41668C6.04186 4.36691 6.45886 3.36013 7.20113 2.61781C7.94341 1.87549 8.95015 1.45842 9.99992 1.45834Z" :fill="getMenuIconColor(currentPath === '/teachers')"/>
          </svg>
        </div>
        <span>师资力量</span>
      </div>
      <!-- 如何上课 -->
      <div 
        class="menu-item" 
        :class="{ active: currentPath === '/help/classroom' }"
        :style="getMenuItemStyle(currentPath === '/help/classroom')"
        @click="navigateTo(menuItems[4])"
      >
        <div class="icon-wrapper">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip_howto)">
              <path d="M4.26426 5.23625C3.12885 5.55452 2.14108 6.26103 1.47303 7.23272C0.804988 8.2044 0.499008 9.37966 0.6084 10.5537C0.717792 11.7278 1.23562 12.8263 2.07168 13.6579C2.90773 14.4894 4.00902 15.0013 5.18369 15.1043C5.36363 15.1188 5.45426 15.1267 5.52519 15.0859C5.59743 15.0439 5.64734 14.9349 5.74979 14.7155C5.88082 14.4441 6.05968 14.1985 6.27781 13.9905C6.56677 13.7081 6.91615 13.5229 7.28261 13.4336C7.5545 13.3679 7.68979 13.3338 7.74758 13.2628C7.80274 13.1906 7.80274 13.0763 7.80274 12.8452V10.7436C7.80274 10.1629 8.03343 9.60599 8.44405 9.19537C8.85467 8.78475 9.41159 8.55407 9.9923 8.55407C10.573 8.55407 11.1299 8.78475 11.5405 9.19537C11.9512 9.60599 12.1818 10.1629 12.1818 10.7436V12.8452C12.1818 13.0763 12.1818 13.1906 12.237 13.2628C12.2935 13.3338 12.4301 13.3679 12.702 13.4336C13.0345 13.5142 13.3434 13.6721 13.6035 13.8943C13.8637 14.1166 14.0678 14.397 14.1993 14.7129C14.2913 14.927 14.3359 15.0347 14.4016 15.0781C14.4673 15.1227 14.5632 15.1227 14.7562 15.1227H14.8088C15.9345 15.1245 17.0217 14.7132 17.8643 13.9668C18.707 13.2204 19.2464 12.1908 19.3805 11.0732C19.5146 9.9555 19.234 8.82748 18.5918 7.90296C17.9496 6.97844 16.9905 6.32167 15.8963 6.05717C15.6836 6.00463 15.5758 5.97967 15.522 5.91794C15.4668 5.85489 15.455 5.74719 15.4301 5.53309C15.2858 4.25999 14.6996 3.07783 13.7734 2.19254C12.8472 1.30726 11.6398 0.774963 10.3614 0.688388C9.08313 0.601813 7.81496 0.966445 6.77785 1.71876C5.74074 2.47108 5.00043 3.5634 4.68588 4.80543C4.64254 4.97618 4.62021 5.06287 4.5703 5.11278C4.5217 5.16401 4.43501 5.18765 4.26426 5.23493V5.23625Z" :fill="getMenuIconColor(currentPath === '/help/classroom')"/>
              <path d="M9.99714 10.4283C10.4882 10.4283 10.8871 10.8259 10.8871 11.3169V15.3199H11.4075C11.5623 15.3199 11.7544 15.3199 11.9092 15.3399H11.9132C12.0253 15.3532 12.5377 15.4186 12.7805 15.9216C13.026 16.4247 12.7578 16.869 12.7005 16.9664L12.6978 16.9704C12.6164 17.1052 12.4977 17.256 12.4002 17.38L12.3762 17.4094C12.1147 17.7443 11.7758 18.1753 11.4369 18.5236C11.2674 18.697 11.0739 18.8758 10.8684 19.0172C10.687 19.1427 10.3748 19.3241 9.9918 19.3241C9.60886 19.3241 9.29796 19.1427 9.11516 19.0172C8.91027 18.8713 8.71992 18.706 8.54674 18.5236C8.20916 18.1753 7.86891 17.7443 7.60605 17.4094L7.58603 17.3827C7.48729 17.2586 7.36854 17.1065 7.28581 16.9691L7.28448 16.9664C7.22577 16.8703 6.95757 16.426 7.20175 15.9216C7.44593 15.4186 7.95831 15.3545 8.07039 15.3399H8.07439C8.23051 15.3199 8.42131 15.3199 8.57743 15.3199H9.10715V11.3169C9.10715 10.8259 9.50611 10.4283 9.99714 10.4283Z" :fill="getMenuIconColor(currentPath === '/help/classroom')"/>
            </g>
            <defs>
              <clipPath id="clip_howto">
                <rect width="20" height="20" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <span>如何上课</span>
      </div>
    </BottomMenuPopup>
    
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import BottomMenuPopup from './BottomMenuPopup.vue'
import { getPlatform, isWeChat } from '@/utils/platform.js'

/**
 * 下载链接配置
 * @property {string} ios - iPhone App Store 链接
 * @property {string} ipad - iPad App Store 链接
 * @property {string} harmonyos_next - 鸿蒙 NEXT 华为应用市场链接
 * @property {string} yyb - 应用宝链接（根据平台自动跳转 iOS 或 Android）
 */
const DOWNLOAD_LINKS = {
  ios: 'https://itunes.apple.com/cn/app//id1335996987?mt=8',
  ipad: 'https://itunes.apple.com/cn/app/id1474353849?mt=8',
  harmonyos_next: 'https://appgallery.huawei.com/app/detail?id=com.ouna.app.hm',
  yyb: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ouna.app.client'
}


/**
 * 路由实例
 */
const router = useRouter()
const route = useRoute()

/**
 * 获取当前站点的 profile
 * @returns {string} 站点 profile (de, fr, es, pt, ru)
 */
const currentProfile = typeof __SITE_PROFILE__ !== 'undefined' ? __SITE_PROFILE__ : 'de'

/**
 * 配置是否已加载完成
 * 用于避免在配置加载前显示错误的默认图片
 */
const configLoaded = ref(false)

/**
 * 图片加载失败标记，用于避免循环请求
 */
const langIconFailed = ref(false)

const headerConfig = ref({
  logo: `/images/${currentProfile}/header-logo.png`,
  langIcon: `/images/${currentProfile}/lang-icon.png`,
  langName: ''
})
const showMenu = ref(false)
const showLangPopover = ref(false)

// 当前选中的语言
const selectedLang = ref('')

/**
 * 菜单项配置
 * @type {Array<{name: string, path: string, icon: string, external?: boolean}>}
 */
const menuItems = [
  { name: '首页', path: '/', icon: 'home' },
  { name: '课程体系', path: '/courses', icon: 'courses' },
  { name: '师资力量', path: '/teachers', icon: 'teacher' },
  { name: '试听列表', path: '/shitings', icon: 'list', external: true },
  { name: '如何上课', path: '/help/classroom', icon: 'howto' }
]

/**
 * 计算当前激活的菜单项
 * @returns {string} 当前路由路径
 */
const currentPath = computed(() => {
  return route.path
})

/**
 * 品牌色配置
 */
const brandColors = {
  es: '#FF5B16',
  fr: '#FF1F59',
  de: '#F93636',
  ru: '#0278DE',
  pt: '#00AA81'
}

/**
 * 获取菜单图标颜色
 * @param {boolean} isActive - 是否选中
 * @returns {string} 颜色值
 */
const getMenuIconColor = (isActive) => {
  if (isActive) {
    return brandColors[currentProfile] || '#F93636'
  }
  return '#AAAAAA'
}

/**
 * 获取菜单项样式
 * @param {boolean} isActive - 是否选中
 * @returns {object} 样式对象
 */
const getMenuItemStyle = (isActive) => {
  if (isActive) {
    return {
      color: brandColors[currentProfile] || '#F93636'
    }
  }
  return {
    color: '#333'
  }
}

/**
 * 导航到指定页面
 * @param {Object} item - 菜单项配置
 */
const navigateTo = (item) => {
  showMenu.value = false
  
  // 如果是外部链接，使用 window.location
  if (item.external) {
    window.location.href = item.path
    return
  }
  
  // 如果当前已经在该页面，不进行跳转
  if (route.path === item.path) {
    return
  }
  
  router.push(item.path)
}

/**
 * 计算属性：获取语言图标路径
 * @returns {string} 语言图标的完整路径
 */
const langIconPath = computed(() => {
  return headerConfig.value.langIcon || `/images/${currentProfile}/lang-icon.png`
})

/**
 * 计算属性：获取语言名称
 * @returns {string} 语言名称
 */
const langNameDisplay = computed(() => {
  return headerConfig.value.langName || ''
})

/**
 * 计算属性：动态生成语言选项列表
 * @returns {Array} 语言选项数组
 */
const langActions = computed(() => {
  return [
    { text: langNameDisplay.value, icon: langIconPath.value }
  ]
})

/**
 * 选择语言事件处理
 * @param {Object} action - 选中的语言选项
 */
const onSelectLang = (action) => {
  // 更新选中的语言
  selectedLang.value = action.text
  headerConfig.value.langName = action.text
  // 关闭下拉菜单
  showLangPopover.value = false
  // 目前只有一个选项，暂时不做跳转
  console.log('Selected lang:', action.text)
}

/**
 * 动态加载当前语言的配置
 * 使用 import.meta.glob 动态导入对应语言的配置文件
 */
const loadConfig = async () => {
  const profile = currentProfile
  try {
    const modules = import.meta.glob('@/stores/*/index.js')
    const path = `/src/stores/${profile}/index.js`
    
    if (modules[path]) {
      const mod = await modules[path]()
      if (mod.default && mod.default.header) {
        headerConfig.value = mod.default.header
        // 同步更新选中的语言
        selectedLang.value = headerConfig.value.langName
      }
    } else {
      console.warn(`Header config for ${profile} not found, using current profile defaults`)
    }
  } catch (e) {
    console.error('Failed to load header config:', e)
  } finally {
    // 无论成功失败，都标记配置已加载完成
    configLoaded.value = true
  }
}

/**
 * 计算"打开App"按钮的样式
 * 根据当前语言站点设置不同的颜色
 * @returns {Object} 样式对象
 */
const openAppBtnStyle = computed(() => {
  const colorMap = {
    es: '#FF5B16', // 西语
    fr: '#FF1F59', // 法语
    de: '#F93636', // 德语
    ru: '#0278DE', // 俄语
    pt: '#00AA81'  // 葡语
  }
  
  const color = colorMap[currentProfile] || '#333'
  
  return {
    color: color,
    borderColor: color,
    backgroundColor: '#fff'
  }
})

/**
 * 处理"打开App"按钮点击
 * 逻辑与下载页面相同：
 * 1. 检测当前平台
 * 2. 判断是否在微信内打开
 * 3. 根据平台跳转到对应应用商店
 */
const handleOpenApp = () => {
  const platform = getPlatform()
  const inWeChat = isWeChat()
  
  console.log('[Header] Open App clicked, platform:', platform, 'WeChat:', inWeChat)
  
  // 微信环境特殊处理：统一跳转应用宝（应用宝会处理后续的下载和浏览器引导）
  if (inWeChat) {
    if (platform === 'ios' || platform === 'ipad') {
      // iOS/iPad 微信：直接跳转应用宝（应用宝会处理下载和浏览器引导）
      window.location.href = DOWNLOAD_LINKS.yyb
      return
    } else if (platform === 'android' || platform === 'harmonyos') {
      // Android / 旧版鸿蒙 微信：直接跳转应用宝
      window.location.href = DOWNLOAD_LINKS.yyb
      return
    } else if (platform === 'harmonyos_next') {
      // 鸿蒙 NEXT 微信：跳转华为应用市场
      window.location.href = DOWNLOAD_LINKS.harmonyos_next
      return
    }
  }
  
  // 非微信环境：直接跳转到对应应用商店
  switch (platform) {
    case 'ios':
      window.location.href = DOWNLOAD_LINKS.ios
      break
    case 'ipad':
      window.location.href = DOWNLOAD_LINKS.ipad
      break
    case 'harmonyos_next':
      window.location.href = DOWNLOAD_LINKS.harmonyos_next
      break
    case 'android':
    case 'harmonyos':
      // Android / 旧版鸿蒙：直接跳转应用宝
      window.location.href = DOWNLOAD_LINKS.yyb
      break
    default:
      // PC端或其他：跳转到下载页面
      router.push('/help/classroom')
  }
}

/**
 * 切换菜单显示状态
 */
const toggleMenu = () => {
  showMenu.value = !showMenu.value
  console.log('Menu toggled, showMenu:', showMenu.value)
}

/**
 * 切换语言下拉菜单显示状态
 */
const toggleLangPopover = () => {
  showLangPopover.value = !showLangPopover.value
}

/**
 * 图片加载错误处理
 * 避免循环请求：如果已经失败过，不再尝试加载
 * @param {Event} e - 错误事件对象
 */
const handleImageError = (e) => {
  // 如果已经尝试过 fallback，不再重复尝试，避免循环请求
  if (langIconFailed.value) {
    console.warn('Language icon load failed, hiding icon')
    // 隐藏图片元素，避免显示破损图标
    e.target.style.display = 'none'
    return
  }
  
  console.error('Language icon load error:', e.target.src)
  langIconFailed.value = true
  
  // 尝试使用通用图标或隐藏
  // 这里直接隐藏，因为没有可靠的 fallback 图片
  e.target.style.display = 'none'
}

/**
 * 点击外部关闭下拉菜单
 * @param {Event} event - 点击事件对象
 */
const handleClickOutside = (event) => {
  const langSwitchWrapper = event.target.closest('.lang-switch-wrapper')
  if (!langSwitchWrapper && showLangPopover.value) {
    showLangPopover.value = false
  }
}

onMounted(() => {
  loadConfig()
  
  // 添加点击外部关闭事件
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  // 移除事件监听
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped lang="scss">
.header-container {
  height: 54px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  box-sizing: border-box;

  .header-left {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .logo {
      height: 42px; // 稍微减小Logo高度以匹配图片
      width: auto;
      display: block;
    }

    .lang-switch-wrapper {
      display: inline-flex;
      align-items: center;
      position: relative;
      margin-left: 12px;
    }
    
    .lang-dropdown-menu {
      position: absolute;
      top: calc(100% + 6px);
      left: 0;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      min-width: 120px;
      padding: 4px 0;
      z-index: 1000;
      border: 1px solid #E8E8E8;
      overflow: hidden;
      
      .lang-dropdown-item {
        display: flex;
        align-items: center;
        padding: 8px 14px;
        cursor: pointer;
        transition: background-color 0.2s;
        font-size: 13px;
        color: #333;
        
        &:hover {
          background-color: #f8f8f8;
        }
        
        &.active {
          color: #333;
          font-weight: 500;
          background-color: #f8f8f8;
        }
        
        .lang-dropdown-icon {
          width: 16px;
          height: 16px;
          margin-right: 8px;
          border-radius: 50%;
          object-fit: cover;
        }
      }
    }

    .lang-switch {
      display: inline-flex;
      align-items: center;
      white-space: nowrap;
      cursor: pointer;
      background-color: #fff;
      transition: border-color 0.2s;
      height: 26px;
      box-sizing: border-box;
      
      &:hover {
        border-color: #D5D5D5;
      }
      
      .lang-icon {
        width: 16px;
        height: 16px;
        margin-right: 5px;
        display: block;
        flex-shrink: 0;
        object-fit: cover;
        border: none;
        outline: none;
      }
      
      .lang-name {
        font-size: 13px;
        color: #333;
        font-weight: 400;
        flex-shrink: 0;
        line-height: 1;
        margin-right: 3px;
      }
      
      .arrow-icon {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
        transition: transform 0.2s;
        display: inline-block;
        vertical-align: middle;
      }
      
      // 当下拉菜单打开时，箭头向上旋转
      &.active .arrow-icon {
        transform: rotate(180deg);
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .open-app-btn {
      // 背景色、文字颜色和边框颜色通过内联样式动态设置
      background-color: #fff; // 白色背景
      height: 28px; // 增加高度
      line-height: 28px;
      padding: 0 16px; // 增加左右内边距
      font-size: 14px; // 增加字体大小
      margin-right: 25px; // 增加与菜单图标的间距
      border-radius: 14px; // 圆角，pill形状
      border: 1px solid; // 边框，颜色通过内联样式设置
      font-weight: normal; // 去掉加粗，看起来更像普通文本
      white-space: nowrap;
      cursor: pointer;
    }

    .menu-icon {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
// 菜单项样式（需要在全局样式中定义，因为它们在 slot 中）
.menu-item {
  display: flex;
  align-items: center;
  padding: 18px 0;
  font-family: var(--NotoSansSimplified);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #333;
  position: relative;
  cursor: pointer;
  transition: color 0.2s;
  
  &:active {
    opacity: 0.7;
  }
  
  .icon-wrapper {
    width: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
  
  &.active {
    font-weight: 400;
    
    &::before {
      content: '';
      position: absolute;
      left: -30px;
      right: 100%;
      top: 50%;
      height: 1px;
      border-top: 1px dashed #ccc;
      width: 40px;
      z-index: -1;
    }
  }
}
</style>
